module.exports = __webpack_public_path__ + "img/demo_woman1.f3ab1402.svg";